module.exports = __webpack_public_path__ + "static/moonamar-hladno-cijedeno-ulje-corokota-crnog-kima-ac48496451ae5fb5b8500530be72b460.png";